import { FlowStep, FlowType } from 'src/frontend/constants/GettingStartedFlows';

import { SidebarService } from '@diagram/services/SidebarService';
import { gettingStartedTourState } from '@diagram/state/getting-started-tour';
import { SidebarType } from '@diagram/state/sidebar';

import { DriverService } from 'services/drivers/DriverService';

export enum ExpertSupportTourStep {
    SHOW_BADGE = 'expert-support-show-badge',
    OPEN_CHANNEL = 'expert-support-open-channel',
    FINISH = 'expert-support-finish',
}

const STEP_SEQUENCE: ExpertSupportTourStep[] = [
    ExpertSupportTourStep.SHOW_BADGE,
    ExpertSupportTourStep.OPEN_CHANNEL,
    ExpertSupportTourStep.FINISH,
];

const HIGHLIGHTS: Partial<Record<ExpertSupportTourStep, FlowStep>> = {
    [ExpertSupportTourStep.SHOW_BADGE]: {
        selector: '[data-tour-support]',
        popover: {
            title: 'Get engineering support',
            description: `
                <p>Click here to start a conversation with our engineers.</p>
                <p>We'll set up a direct chat channel for your project.</p>
            `,
        },
    },
    [ExpertSupportTourStep.OPEN_CHANNEL]: {
        selector: '[data-diagram-sidebar]',
        popover: {
            title: "You're connected!",
            description: `
                <p>This is your direct line toour team of experts.</p>
                <p>Whether you’re designing your first DC power system or refining a complex project, our experts are here to help. Ask about protection, droop control, equipment selection, troubleshooting, or anything else.</p>
            `,
        },
        isLastStep: true,
    },
};

const ExpertSupportDriverService = {
    start: async (initStep: ExpertSupportTourStep = ExpertSupportTourStep.SHOW_BADGE) => {
        DriverService.request(FlowType.EXPERT_SUPPORT);

        DriverService.setStep(FlowType.EXPERT_SUPPORT, initStep);
    },

    showHighlight: (step: ExpertSupportTourStep) => {
        const highlight = HIGHLIGHTS[step];

        if (!highlight) {
            return null;
        }

        return DriverService.showHighlight(FlowType.EXPERT_SUPPORT, highlight);
    },

    advance: () => {
        DriverService.advance(FlowType.EXPERT_SUPPORT, STEP_SEQUENCE);
    },

    onChannelOpened: () => {
        if (gettingStartedTourState.activeTourStep === ExpertSupportTourStep.SHOW_BADGE) {
            ExpertSupportDriverService.advance();
        }
    },
};

export { ExpertSupportDriverService };
